import { OutlinedInput, styled } from '@mui/material';

export const PartsItem = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  padding: '8px 16px',
  borderRadius: 8,
  background: theme.palette.common.white,
  boxShadow: theme.customShadows.z1,
}));

export const PartsInput = styled(OutlinedInput)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
}));
